export default {
  'dashboard.alert.timezone': '确认您的所在地时区，解锁更准确的时间提示。',
  'dashboard.timezone': '所在地时区',
};
